import loadable from '@loadable/component';

export const NewobjectsLoadable = loadable(
  () => import('./Newobjects').catch(/* istanbul ignore next */ () => ({ Newobjects: () => null })),
  {
    resolveComponent: ({ Newobjects }) => Newobjects,
  },
);
